import api from "../../infra/api";

class ServOcupante {
    async listar(codigoResp, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"Situacao","operator":"in","value":[1,4],"and":true,"not":false}]`
                : `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"Situacao","operator":"in","value":[1,4],"and":true,"not":false},{"property":"Nome","operator":"containsall","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async listarCFiltroCode(codigoResp, filtro) {
        const response = await api({
            method: "GET",
            url: !filtro || filtro === 0
                ? `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":false}]`
                : `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false},{"property":"Codigo","operator":"equal","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async listarCFiltros(codigoResp, pesquisaGeral) {
        let url = `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`;

        if (pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);
            url += `,{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}"},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","value":"${pesquisaGeral}","and":false},{"property":"NomeRepresentante","value":"${pesquisaGeral}","and":false},{"property":"Codigo","value":"${pesquisaGeral}","and":false}]`;
        }

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCfeSituacaoOuData(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        let url = filter.trim() === "" ?
            `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTec","value":"${codigoResp}","and":true,"not":false}]` :
            `/api/v1/Ocupante?page=1&start=0&limit=999&fields=["Situacao","Codigo","Nome","Inscricao","NomeRepresentante","CpfRepresentante","NumeroTermoAutorizacao","ProcessoAnatel","DataPrazoAnalise","DataAto","DataEnvioHomologacao","DataCadastro","CodigoResponsavelTecnico","Id","Cep","Uf","Numero","Endereco","Bairro","CodigoUsoMutuo","CodigoCidade","NumeroContrato","Cidades","Ativo"]&sort=[{"property":"Codigo","direction":"DESC"}]&filter=${filter}`;

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async RecuperarParaEditar(codigoOcupante) {
        const response = await api({
            method: "GET",
            url: `api/v1/Ocupante/${codigoOcupante}`
        });

        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral.trim() !== "";

        if (temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = "," + filtroSituacaoDatas.slice(1);

            return `[{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"NomeRepresentante","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CpfRepresentante","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao);
        let campoParaFiltrarData = (tipoDataFiltro === "data-cadastro") ? "DataCadastro" : "DataEnvioHomologacao";

        if (temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"Codigo","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } else if (!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"Codigo","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } else {
            return `[{"property":"Codigo","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    retornarFilterDeAcordoComFiltros(filtro, situacoes, codigo) {
        let temPesquisaGeral = filtro.trim() !== "";

        if (temPesquisaGeral) {
            let filtroTipoSituacao = this.handleFiltrosESituacao(situacoes, codigo);
            let filtroFinal = "," + filtroTipoSituacao.slice(1);

            return `[{"property":"Descricao","operator":"containsall","value":"${filtro}","and":false}` + filtroFinal;
        } else {
            return this.handleFiltrosESituacao(situacoes, codigo);
        }
    }

    handleFiltrosESituacao(situacoes, codigo) {
        let filtros = [];

        // Adiciona o filtro de código, se informado
        if (codigo) {
            filtros.push({ "property": "Codigo", "operator": "equal", "value": codigo, "and": true, "not": false });
        }

        // Verifica se há situações informadas
        if (situacoes.length > 0) {
            let arraySituacaoFormatada = JSON.stringify(situacoes);
            filtros.push({ "property": "Situacao", "operator": "in", "value": situacoes, "and": true, "not": false });
        }

        return JSON.stringify(filtros);
    }

    async inserir(
        codigoResponsavel,
        nome,
        inscricao,
        codigoCidade,
        Cidades,
        uf,
        endereco,
        numero,
        bairro,
        cep,
        nomeRepresentante,
        cpfRepresentante,
        numeroTermoAutorizacao,
        dataAto,
        processoAnatel,
        numeroContrato,
        situacao,
        dataEnvioHomologacao,
        dataPrazoAnalise,
        cadastradoPorAnalista
    ) {
        const response = await api({
            method: "POST",
            url: "api/v1/Ocupante",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                CodigoResponsavelTecnico: codigoResponsavel,
                Nome: nome,
                Inscricao: inscricao,
                CodigoCidade: codigoCidade,
                Cidade: Cidades,
                Uf: uf,
                Endereco: endereco,
                Numero: numero,
                Bairro: bairro,
                Cep: cep,
                NomeRepresentante: nomeRepresentante,
                CpfRepresentante: cpfRepresentante,
                NumeroTermoAutorizacao: numeroTermoAutorizacao,
                DataAto: dataAto,
                ProcessoAnatel: processoAnatel,
                NumeroContrato: numeroContrato,
                Situacao: situacao,
                DataCadastro: new Date(),
                DataEnvioHomologacao: dataEnvioHomologacao,
                DataPrazoAnalise: dataPrazoAnalise,
                CodigoUsoMutuo: "",
                CadastradoPorAnalista: cadastradoPorAnalista
            })
        });

        return response.data;
    }

    async editar(
        Id,
        codigoResponsavel,
        codigoUsoMutuo,
        descricaoUsoMutuo,
        nome,
        inscricao,
        codigoCidade,
        Cidades,
        uf,
        endereco,
        numero,
        bairro,
        cep,
        nomeRepresentante,
        cpfRepresentante,
        numeroTermoAutorizacao,
        dataAto,
        processoAnatel,
        numeroContrato,
        situacao,
        dataCadastro,
        dataEnvioHomologacao,
        dataPrazoAnalise
    ) {

        const response = await api({
            method: "PUT",
            url: "api/v1/Ocupante",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                Id: Id,
                CodigoResponsavelTecnico: codigoResponsavel,
                CodigoUsoMutuo: codigoUsoMutuo,
                DescricaoUsoMutuo: descricaoUsoMutuo,
                Nome: nome,
                Inscricao: inscricao,
                CodigoCidade: codigoCidade,
                Cidades: Cidades,
                Uf: uf,
                Endereco: endereco,
                Numero: numero,
                Bairro: bairro,
                Cep: cep,
                NomeRepresentante: nomeRepresentante,
                CpfRepresentante: cpfRepresentante,
                NumeroTermoAutorizacao: numeroTermoAutorizacao,
                DataAto: dataAto,
                ProcessoAnatel: processoAnatel,
                NumeroContrato: numeroContrato,
                Situacao: situacao,
                Ativo: true,
                DataCadastro: dataCadastro,
                DataEnvioHomologacao: dataEnvioHomologacao,
                DataPrazoAnalise: dataPrazoAnalise
            })
        });

        return response.data;
    }

    async revisar(
        id,
        motivo,
        enviarEmailRespTecnico
    ) {

        const response = await api({
            method: "PUT",
            url: "api/v1/Ocupante/Revisar",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                Id: id,
                Motivo: motivo,
                EnviarEmailRespTecnico: enviarEmailRespTecnico
            })
        });

        return response.data;
    }

    async revisaoInterna(
        id,
        motivo,
        enviarEmailRespTecnico
    ) {

        const response = await api({
            method: "PUT",
            url: "api/v1/Ocupante/RevisaoInterna",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                Id: id,
                Motivo: motivo,
                EnviarEmailRespTecnico: enviarEmailRespTecnico
            })
        });

        return response.data;
    }

    async homologar(
        codigoOcupante,
        enviarEmailRespTecnico
    ) {

        const response = await api({
            method: "PUT",
            url: "api/v1/Ocupante/Homologar",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                CodigoOcupante: codigoOcupante,
                EnviarEmailRespTecnico: enviarEmailRespTecnico
            })
        });

        return response.data;
    }

    async VerificarCadastro(inscricao) {
        const response = await api({
            method: "GET",
            url: `/api/v1/Ocupante/VerificarCadastro/${inscricao}`,
            headers: {
                "Content-Type": "application/json",
            }
        });

        return response.data;
    }

    async SolicitarHomologacao(codigoOcupante) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/Ocupante/SolicitarHomologacao/${codigoOcupante}`
        });

        return response.data;
    }

    async Cancelar(codigoOcupante) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/Ocupante/Cancelar/${codigoOcupante}`
        });

        return response.data;
    }

    async Inativar(codigoOcupante) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/Ocupante/Inativar/${codigoOcupante}`
        });

        return response.data;
    }

    async Ativar(codigoOcupante) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/Ocupante/Ativar/${codigoOcupante}`
        });

        return response.data;
    }

    async Arquivar(codigoOcupante) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/Ocupante/Arquivar/${codigoOcupante}`
        });

        return response.data;
    }

    async RecuperarResponsaveis(codigoOcupante) {
        const response = await api({
            method: "GET",
            url: `/api/v1/Ocupante/RecuperarResponsaveis/${codigoOcupante}`
        });

        return response.data;
    }
}

export default new ServOcupante();